<div id="contact-rank" class="popup" style="display: block">
    <div>
      <a id="close" class="close" (click)="close(false)" tabindex="-1"></a>
      <div class="popup-content">
          <span class="h1 block">Manual Profile Claim</span>
          <form [formGroup]="form" *ngIf="manualClaimModel" name="frmManualClaim">
            <div class="row">
              <div class="field half">
                <input type="text" id="reg-manual-firstName" placeholder="First Name" formControlName="firstName" />
                <label for="reg-manual-firstName">First Name</label>
                <div class="error-container" *ngIf="firstNameInvalid()">
                  <small class="error">First Name is required.</small>
                </div>
              </div>
              <div class="field half">
                <input type="text" id="reg-manual-lastName" placeholder="Last Name" formControlName="lastName" />
                <label for="reg-manual-lastName">Last Name</label>
                <div class="error-container" *ngIf="lastNameInvalid()">
                  <small class="error">Last Name is required.</small>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="field half">
                  <input type="text" id="reg-manual-email" placeholder="Email Address" formControlName="email" />
                  <label for="reg-manual-email">Email Address</label>
                  <div class="error-container" *ngIf="emailInvalid()">
                    <small class="error">Please provide a valid email.</small>
                  </div>
                </div>
                <div class="field half">
                    <input type="text" id="reg-manual-phone" placeholder="Phone Number" formControlName="phone" />
                    <label for="reg-manual-phone">Phone Number</label>
                    <div class="error-container" *ngIf="phoneInvalid()">
                      <small class="error">Phone number is required and must be a valid format.</small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="field">
                  <input type="text" id="reg-manual-website" placeholder="Website" formControlName="website" />
                  <label for="reg-manual-website">Website</label>
                  <div class="error-container" *ngIf="websiteInvalid()">
                    <small class="error">Please provide a valid website.</small>
                  </div>
                </div>
            </div>            
            <div class="field">
              <textarea formControlName="message"></textarea>
              <label for="register-zip">Message</label>
              <div class="error-container" *ngIf="messageInvalid()">
                <small class="error">Message can not be longer than 1,000 characters.</small>
              </div>
            </div>
            <button class="btn primary" [disabled]="!formIsValid()" (click)="submitRequest()">Submit Claim</button>
          </form>
      </div>
    </div>
  </div>
  